<!--
@Time : 2020/11/29 12:50 下午
@Author : yekong
@File : jiankongtu.vue
@Software : PhpStorm
-->
<template>
  <div class="jiankong">
    <div class="title">各级指标监控图</div>
    <div class="jk">
      <div class="jk1"><span></span>正常</div>
      <div class="jk1"><span class="lan"></span>良好</div>
      <div class="jk1"><span class="cheng"></span>预警</div>
    </div>
    <div class="huanxing2">
      <div class="huanxingx c1"><span class="lv"></span>政府采购</div>
      <div class="huanxingx c2"><span></span>获得信贷</div>
      <div class="huanxingx c3"><span class="lan"></span>劳动力市场监督</div>
      <div class="huanxingx c4"><span class="lv"></span>保护中小投资者</div>
      <div class="huanxingx c5"><span class="lv"></span>招标投标</div>
      <div class="huanxingx c6"><span class="lv"></span>政务服务</div>
      <div class="huanxingx c7"><span class="lan"></span>执行合同</div>
      <div class="huanxingx c8"><span class="lv"></span>企业开办</div>
      <div class="huanxingx c9"><span class="cheng"></span>获得电力</div>
      <div class="huanxingx c10"><span class="lan"></span>办理建筑许可</div>
      <div class="huanxingx c11"><span class="lan"></span>获得用水用气</div>
      <div class="huanxingx c12"><span class="lan"></span>登记财产</div>
      <div class="huanxingx c13"><span class="lan"></span>纳税</div>
      <div class="huanxingx c14"><span class="lan"></span>办理破产</div>
      <div class="huanxingx c15"><span class="lan"></span>跨境贸易</div>
      <div class="huanxingx c16"><span class="lv"></span>市场监督</div>
      <div class="huanxingx c17"><span class="cheng"></span>信用建设</div>
      <div class="huanxingx c18"><span class="lan"></span>包容惠普创新</div>
      <div class="huanxingx c19"><span></span>
        知识产权创造、
        保护和运用
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "jiankongtu",
  data: function () {
    return {}
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {},
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
@import "../../main";

.title {
  font-size: 60px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #39F9FF;
  padding-top: 60px;
  height: 80px;
}

.jiankong {
  width: 1700px;
  height: 1800px;
}

.huanxing2 {
  background: url("../../assets/huanxing3.png") center 100px no-repeat;
  width: 1700px;
  height: 1500px;
  position: relative;
}

.jk {
  padding-top: 50px;

  .jk1 {
    height: 80px;
    margin-left: 10px;
    @include flex_start_center();

    span {
      width: 30px;
      height: 30px;
      background: #47FF96;
      margin-right: 27px;
    }

    font-size: 34px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }
}

.lv {
  background: rgba(71, 255, 150, 1) !important;
}

.lan {
  background: rgba(71, 140, 255, 1) !important;
}

.cheng {
  background: rgba(229, 116, 68, 1) !important;
}

.huanxingx {
  position: absolute;
  top: 100px;
  left: 770px;
  width: 236px;
  height: 71px;
  background: linear-gradient(90deg, #848878 0%, rgba(132, 136, 120, 0.3) 100%);
  font-size: 32px;
  font-family: PingFang;
  font-weight: 800;
  color: #181F38;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;

  span {
    width: 24px;
    height: 24px;
    background: #E57444;
    margin-left: 23px;
    flex-shrink: 0;
    margin-right: 15px;
  }
}

.c1 {
  left: 386px;
  top: 196px;
}

.c2 {

}

.c3 {
  width: 313px;
  height: 71px;
  left: 683px;
  top: 259px;
  background: linear-gradient(90deg, #848878 0%, rgba(132, 136, 120, 0.3) 100%);
}

.c4 {
  width: 313px;
  height: 71px;
  left: 1057px;
  top: 249px;
  background: linear-gradient(90deg, #848878 0%, rgba(132, 136, 120, 0.3) 100%);
}

.c5 {
  width: 250px;
  height: 71px;
  left: 557px;
  top: 374px;
  background: linear-gradient(90deg, #848878 0%, rgba(132, 136, 120, 0.3) 100%);
}

.c6 {
  width: 313px;
  height: 71px;
  left: 557px;
  top: 374px;
  background: linear-gradient(90deg, #848878 0%, rgba(132, 136, 120, 0.3) 100%);
}

.c7 {
  left: 892px;
  top: 374px;
  width: 236px;
  height: 71px;
  background: linear-gradient(90deg, #848878 0%, rgba(132, 136, 120, 0.3) 100%);
}

.c8 {
  left: 130px;
  top: 380px;
  width: 236px;
  height: 71px;
  background: linear-gradient(90deg, #848878 0%, rgba(132, 136, 120, 0.3) 100%);
}

.c9 {
  left: 192px;
  top: 506px;
  width: 236px;
  height: 71px;
  background: linear-gradient(90deg, #848878 0%, rgba(132, 136, 120, 0.3) 100%);
}

.c10 {
  left: 97px;
  top: 632px;
  width: 276px;
  height: 71px;
  background: linear-gradient(90deg, #55ABB1 0%, rgba(85, 171, 177, 0.3) 100%);
}

.c11 {
  left: 117px;
  top: 734px;
  width: 276px;
  height: 71px;
  background: linear-gradient(90deg, #55ABB1 0%, rgba(85, 171, 177, 0.3) 100%);
}

.c12 {
  left: 155px;
  top: 850px;
  width: 276px;
  height: 71px;
  background: linear-gradient(90deg, #55ABB1 0%, rgba(85, 171, 177, 0.3) 100%);
}

.c13 {
  left: 281px;
  top: 923px;
  width: 200px;
  height: 71px;
  background: linear-gradient(90deg, #55ABB1 0%, rgba(85, 171, 177, 0.3) 100%);
}

.c14 {
  left: 388px;
  top: 1014px;
  width: 220px;
  height: 71px;
  background: linear-gradient(90deg, #55ABB1 0%, rgba(85, 171, 177, 0.3) 100%);
}

.c15 {
  left: 658px;
  top: 1064px;
  width: 220px;
  height: 71px;
  background: linear-gradient(90deg, #55ABB1 0%, rgba(85, 171, 177, 0.3) 100%);
}

.c16 {
  left: 1009px;
  top: 1050px;
  width: 220px;
  height: 71px;
  background: linear-gradient(90deg, #55ABB1 0%, rgba(85, 171, 177, 0.3) 100%);
}

.c17 {
  left: 1273px;
  top: 978px;
  width: 220px;
  height: 71px;
  background: linear-gradient(90deg, #55ABB1 0%, rgba(85, 171, 177, 0.3) 100%);
}

.c18 {
  left: 1437px;
  top: 785px;
  width: 294px;
  height: 71px;
  background: linear-gradient(90deg, #6FAEE4 0%, rgba(111, 174, 228, 0.3) 100%);
}

.c19 {
  left: 1250px;
  top: 405px;
  width: 312px;
  line-height: 40px;
  height: 131px;
  background: linear-gradient(90deg, #70AFE5 0%, rgba(112, 175, 229, 0.3) 100%);
}
.c6 {
  left: 1303px;
  top: 603px;
  width: 236px;
  height: 71px;
  background: linear-gradient(90deg, #6FAEE4 0%, rgba(111, 174, 228, 0.3) 100%);
}
</style>
